import React, { Component } from 'react';
import { components } from 'react-select';
import { SELECT_ALL_KEY } from '../MultiSelectField';


export default class CustomValueContainer extends Component {
  render() {
    const { selectProps, getValue, children } = this.props;
    const isDisabled = selectProps.disabled;

    // selected value
    const values = getValue();
    const hasSelectAll = values.some(v => v.key === SELECT_ALL_KEY);
    const filteredValues = values.filter((v) => v.key !== SELECT_ALL_KEY);

    if (isDisabled) {
      const selectedLabels = hasSelectAll ? 'All' : filteredValues.map((v) => v.label).join(', ');
      return (
        <div
          style={{
            padding: '6px 8px',
            color: '#bcbac4',
          }}
        >
          {selectedLabels}
        </div>
      );
    }

    const modifiedChildren = React.Children.map(children, (child) => {
      if (!React.isValidElement(child)) return child;

      if (child.type === components.MultiValue) {
        if (child.props.data?.key === SELECT_ALL_KEY) {
          return null;
        }
        if (hasSelectAll) {
          return null;
        }
      }

      return child;
    });

    return (
      <components.ValueContainer {...this.props}>
        {hasSelectAll ? (
          <>
            <div
              style={{
                padding: '6px 8px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <span>All</span>
            </div>
            {children.filter((child) => child.type === components.Input)}
          </>
        ) : (
          modifiedChildren
        )}
      </components.ValueContainer>
    );
  }
}
